import { ExclamationCircleOutlined } from '@ant-design/icons';
import { FormInstance, Modal, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { useBlocker } from 'react-router-dom';

type UseDiscardChangesModal = (
  form: FormInstance
) => [React.Dispatch<React.SetStateAction<boolean>>];

const discardChangesModal = (
  form: FormInstance,
  setIsDirty: React.Dispatch<React.SetStateAction<boolean>>
) => {
  return new Promise((resolve) => {
    const modal = Modal.confirm({});
    modal.update({
      title: 'Deseja salvar as alterações?', // TODO: TRADUZIR ISSO AQUI DEPOIS
      icon: <ExclamationCircleOutlined />,
      content: (
        <Typography.Text>
          <Trans>
            Você possui modificações em andamento que podem ser perdidas ao sair da página. Você
            deseja:
          </Trans>
        </Typography.Text>
      ),
      cancelText: 'Descartar alterações', // TODO: TRADUZIR ISSO AQUI DEPOIS
      cancelButtonProps: {
        onClick: () => {
          setIsDirty(false);
          form.resetFields();
          modal.destroy();
          resolve(true);
        },
      },
      okText: 'Salvar', // TODO: TRADUZIR ISSO AQUI DEPOIS
      okButtonProps: {
        onClick: () => {
          setIsDirty(false);
          form.submit();
          modal.destroy();
          resolve(false);
        },
      },
      closable: true,
      maskClosable: true,
    });
  });
};

const useDiscardChangesModal: UseDiscardChangesModal = (form) => {
  const [isDirty, setIsDirty] = useState<boolean>(false);

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isDirty && currentLocation.pathname !== nextLocation.pathname
  );

  useEffect(() => {
    const discardChanges = async () => {
      if (blocker.state === 'blocked' && (await discardChangesModal(form, setIsDirty))) {
        setTimeout(blocker.proceed, 0);
      }
    };

    discardChanges();
  }, [blocker, form]);

  return [setIsDirty];
};

export default useDiscardChangesModal;
